import { DaoModel } from '@dynameat/models';

export class LinkTree extends DaoModel {
  constructor(guid, pointOfSale, menus, name) {
    super(guid);
    this.pointOfSale = pointOfSale;
    this.menus = menus || [];
    this.name = name;
  }

  static toInstance(props = {}) {
    return new LinkTree(props.guid, props.point_of_sale, props.menus, props.name);
  }

  serialize() {
    return {
      ...super.serialize(),
      point_of_sale: this.pointOfSale,
      menus: this.menus,
      name: this.name
    };
  }
}
